<script>
    let loggedUser = {};

    firebase.auth().onAuthStateChanged((user) => {
        if(user){
            loggedUser = user;
        }
    });

    function logout(){
        firebase.auth().signOut();
    }
</script>

<li class="nav-item dropdown">
    <a class="nav-link dropdown-toggle text-muted waves-effect waves-dark" href="" data-toggle="dropdown"
       aria-haspopup="true" aria-expanded="false"><img src="{loggedUser.photoURL}" alt="user"
                                                       class="profile-pic" /></a>
    <div class="dropdown-menu dropdown-menu-right scale-up">
        <ul class="dropdown-user">
            <li>
                <div class="dw-user-box">
                    <div class="u-img"><img src="{loggedUser.photoURL}" alt="user"></div>
                    <div class="u-text">
                        <h4>{loggedUser.displayName}</h4>
                        <p class="text-muted">{loggedUser.email}</p>
                        <a href="#" class="btn btn-rounded btn-danger btn-sm">View Profile</a>
                    </div>
                </div>
            </li>
            <!--                            <li role="separator" class="divider"></li>-->
            <!--                            <li><a href="#"><i class="ti-user"></i> My Profile</a></li>-->
            <li role="separator" class="divider"></li>
            <li><a on:click={logout}><i class="fa fa-power-off"></i> Logout</a></li>
        </ul>
    </div>
</li>